// extracted by mini-css-extract-plugin
module.exports = {"errorMainWindow":"style_errorMainWindow__3vqRM","msg":"style_msg__2pFTB"};